import React from "react";
import { useIntl } from "react-intl";
import type { NigeriaGeneralAttendanceRegisterRecord } from "../../../../__generated__/base.gql";
import { isDefined } from "../../_lib/is-defined";
import { RegisterTable } from "../../_lib/register-table";
import useTimeZone from "../../_lib/use-time-zone";
import type { NigeriaGeneralAttendanceRegisterQuery } from "./__generated__/page.gql";
import { createRowFormatter } from "./createRowFormatter";
import { getViewColumns } from "./getViewColumns";

export const NigeriaGeneralAttendanceRegisterTable = ({
  currentPage,
  setCurrentPage,
  loading,
  data,
}: {
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  loading: boolean;
  data?: NigeriaGeneralAttendanceRegisterQuery;
}) => {
  const { formatMessage } = useIntl();
  const timeZone = useTimeZone();
  const rowFormatter = createRowFormatter(timeZone, formatMessage);

  return (
    <RegisterTable
      errorBoundaryName="nigeria-general-attendance-register-table"
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      loading={loading}
      columns={getViewColumns(formatMessage)}
      rows={
        data?.nigeriaGeneralAttendanceRegister?.records
          ?.filter(isDefined)
          .map((e) =>
            rowFormatter(e as NigeriaGeneralAttendanceRegisterRecord),
          ) || []
      }
      totalRows={data?.nigeriaGeneralAttendanceRegister?.total ?? 0}
    />
  );
};
